import { Badge, Grid, Paper, Space, Text } from '@mantine/core';

import { useGetProphetKeywordStats } from '../../api/getKeywordStats';

export const KeywordStats = ({ pageId }: { pageId: string }) => {
  const { data } = useGetProphetKeywordStats({ pageId });
  const stats = data?.stats || [];

  return (
    <Grid columns={2}>
      {stats.map((s) => {
        const keywords = s.keywords ?? {};
        const hasKeywords = Object.keys(keywords).length > 0;

        return (
          <Grid.Col key={s._id} span={1}>
            <Paper shadow="md" radius="md" p="md">
              <Text>{s.date.replaceAll('/', '.')}</Text>
              <Text>Кодовые</Text>
              <Space h="xs" />

              {hasKeywords ? (
                Object.entries(keywords).map(([keyword, count]) => (
                  <Badge key={keyword} variant="light" color="violet" mr="xs" mb="xs" radius="md">
                    {keyword}: {count}
                  </Badge>
                ))
              ) : (
                <Text size="sm" c="dimmed">
                  Нет ключевых слов
                </Text>
              )}
            </Paper>
          </Grid.Col>
        );
      })}
    </Grid>
  );
};
